<template>
  <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
      <!--      <img class="mx-auto h-10 w-auto" src="/logo.png"-->
      <!--           alt="Your Company"/>-->
      <h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">ログインして下さい</h2>
    </div>

    <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
      <div id="error"
           class="flex p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800"
           role="alert" style="display:none;">
        <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20"
             xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"></path>
        </svg>
        <span class="sr-only">Info</span>
        <div>
          ID又はパスワードが違います
        </div>
      </div>
      <form class="space-y-6">
        <div>
          <label for="email" class="block text-sm font-medium leading-6 text-gray-900">メールアドレス</label>
          <div class="mt-2">
            <input id="email" name="email" type="email" autocomplete="email" required="" v-model="email"
                   class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
            <p id="email-error" class="mt-2 text-sm text-red-600 dark:text-red-500" style="display: none">
              メールアドレスを入力して下さい</p>
          </div>
        </div>

        <div>
          <div class="flex items-center justify-between">
            <label for="password" class="block text-sm font-medium leading-6 text-gray-900">パスワード</label>
            <a class="text-sm text-blue-600 decoration-2 hover:underline font-medium" href="https://auth.mud.redigiform.com/reset" target="_blank">パスワードをお忘れですか？</a>
          </div>
          <div class="mt-2">
            <input id="password" name="password" type="password" autocomplete="current-password" required=""
                   v-model="password"
                   class="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"/>
          </div>
          <p id="password-error" class="mt-2 text-sm text-red-600 dark:text-red-500" style="display: none">
            パスワードを入力して下さい</p>
        </div>
        <div>
          <button type="button"
                  class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  @click="login()">
            <div role="status" id="loading" style="display: none">
              <svg aria-hidden="true"
                   class="inline w-6 h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                   viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"/>
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"/>
              </svg>
              <span class="sr-only">Loading...</span>
            </div>
            ログイン
          </button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import {getAuth, signInWithEmailAndPassword, onAuthStateChanged} from "firebase/auth";
import firebase from "../composables/firebaseInit";

export default {
  name: 'Login',
  props: {
    setUser: {
      type: Function,
      required: true
    }
  },
  data: () => {
    return {
      email: "",
      password: "",
    }
  },
  mounted() {
    const auth = getAuth(firebase);
    onAuthStateChanged(auth, (user) => {
      if (user) this.setUser(user)
    });
  },
  methods: {
    login: function () {
      let em = this.email + (this.email.includes("@") ? "" : "@test.com")
      if (!this.password) {
        document.getElementById("password").classList.add("ring-red-500")
        document.getElementById("password-error").style.display = "block"
      } else {
        document.getElementById("password").classList.remove("ring-red-500")
        document.getElementById("password-error").style.display = "none"
      }
      if (!em || !em.match(/.+@.+\..+/)) {
        document.getElementById("email").classList.add("ring-red-500")
        document.getElementById("email-error").style.display = "block"
      } else {
        document.getElementById("email").classList.remove("ring-red-500")
        document.getElementById("email-error").style.display = "none"
      }
      if (!em || !this.password || !em.match(/.+@.+\..+/)) return
      const auth = getAuth();
      document.getElementById('loading').style.display = "block";
      document.getElementById('loading').parentElement.disabled = true;
      signInWithEmailAndPassword(auth, em, this.password)
        .then(() => {
          document.getElementById('loading').style.display = "none";
          document.getElementById('loading').parentElement.disabled = false;
          // location.href = "/"
        })
        .catch(() => {
          document.getElementById('error').style.display = "block"
          document.getElementById('loading').style.display = "none";
          document.getElementById('loading').parentElement.disabled = false;
        });
    }
  }
}

</script>
